import { ControlledMenu, MenuItem } from "@szhsin/react-menu";
import { Handle, Position } from "@xyflow/react";
import { useState } from "react";

export default function DeviceNode(props: any) {
  const [isOpen, setOpen] = useState<any>(false);
  const [anchorPoint, setAnchorPoint] = useState<any>({ x: 0, y: 0 });

  const viewConnectionInfo = () => {
    props.data.onEditConnectionInfo();
  };

  return (
    <>
      <Handle type="source" position={Position.Right} />
        <div
            onContextMenu={(e) => {
                if (typeof document.hasFocus === "function" && !document.hasFocus()) return;

                e.preventDefault();
                setAnchorPoint({x: e.clientX, y: e.clientY});
                setOpen(true);
            }}>
            <img src={require("../../../../../../assets/images/hardware/device0.png")} alt="" width={120} height={120}/>
            <span className="node-title">{props.data.title}</span>

            <ControlledMenu anchorPoint={anchorPoint} state={isOpen ? "open" : "closed"} direction="right"
                            onClose={() => setOpen(false)}>
                <MenuItem onClick={viewConnectionInfo}>
                    <i className="pi pi-info me-3"></i>
                    <span>Info</span>
                </MenuItem>
            </ControlledMenu>
        </div>
    </>
  );
}
